import { authData } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { errorHandler } from "src/app/util/errorHandler";

@Component({
  selector: "app-results-print",
  templateUrl: "./results-print.component.html",
})
export class ResultsPrintComponent implements OnInit {
  constructor(private route: ActivatedRoute, private httpClient: HttpClient, private router: Router) {}
  session = "";
  term = "";
  sessions: any = [];
  terms: any = [
    {
      Id: 1,
      Label: "1st"
    },
    {
      Id: 2,
      Label: "2nd"
    },
    {
      Id: 3,
      Label: "3rd"
    },
  ];
  isMidTerm: boolean = false;
  notification: any = {};
  noContentFound: boolean = false;

  skeletonLoader = true;
  downloader: any = null;

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + authData().Token,
    }),
  };

  ngOnInit(): void {
    this.isMidTerm = this.route.snapshot.paramMap.get("isMidTerm") == 'true';
    console.log(this.isMidTerm);
    const baseUrl = `${environment.BASE_URL}/results/semesterSession`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        this.skeletonLoader = false;
        if (res.Success) {
          this.sessions = res.Data?.Sessions;
        }
        else {
          this.notification = {
            error: true,
            message:
              res.Message,
          };
        }
      },
      (err) => {
        this.skeletonLoader = false;
        this.noContentFound = err.status === 404;
        this.notification = {
          error: true,
          message:
            err?.error?.Message || "An error occurred. Please, try again",
        };
      }
    );
  }

  printResult() {
    if (!this.session || !this.term) return;

    this.notification = {};
    this.downloader = {
      loading: true,
    };

    const baseUrl = `${environment.BASE_URL}/results/printResults?session=${this.session}&term=${this.term}&isMidTerm=${this.isMidTerm}`;
    this.httpClient.get(baseUrl, this.httpOptions).subscribe(
      (res: any) => {
        if (res.Data == null || !res.Success) {
          this.downloader = null;
          this.notification = {
            error: true,
            message: res.Message
          }
        }
        else {
          this.downloader = {
            loading: false,
            url: "data:application/octet-stream;base64," + res.Data?.Data,
          };
        }
      },
      (err) => {
        this.downloader = null;
        this.notification = errorHandler(err);
      }
    );
  }
}
